<div class="wrapper">
  {{text()}}
  <div
    class="background"
    [style.backgroundColor]="color()"
    [style.outlineColor]="color()"
  >
    {{text()}}
  </div>

  <div class="overlay">
    {{text()}}
  </div>

  <div class="name" [style.color]="color()">
    {{text()}}
  </div>
  <div class="name-overlay">
    {{text()}}
  </div>
</div>
